import qrcode from 'qrcode-generator';
import { captureError } from '@/sentry';

export function makeQrSvg(data: string): string | null {
  if (!data) return null;
  try {
    const qr = qrcode(0, 'M');
    qr.addData(data);
    qr.make();
    return qr.createSvgTag({
      cellSize: 6,
      margin: 1,
      scalable: true,
    });
  } catch (error) {
    captureError(error, { scope: 'qr', action: 'makeQrSvg' });
    return null;
  }
}
